import { render, staticRenderFns } from "./ModalCrearUnidadCompuesta.vue?vue&type=template&id=3fd2fe0a&"
import script from "./ModalCrearUnidadCompuesta.vue?vue&type=script&lang=js&"
export * from "./ModalCrearUnidadCompuesta.vue?vue&type=script&lang=js&"
import style0 from "./ModalCrearUnidadCompuesta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports